<template>
  <b-tabs class="d-flex flex-column">
    <b-tab v-if="checkClaim(CAN_VIEW_ALL_OFFERS)">
      <template v-slot:title>
        Offers &nbsp;<b-badge variant="primary">{{ offersList.length }}</b-badge>
      </template>
      <offers-tab :reqLineId="reqLineId" :partId="partId" />
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Sources &nbsp;<b-badge variant="primary">{{sourcesList.length}}</b-badge>
      </template>
      <sources-tab :reqLineId="reqLineId" />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
      <template v-slot:title>
        I/C/E &nbsp;<b-badge variant="primary">{{ inventoryListForPart.length }}</b-badge>
      </template>
      <inventory-tab :reqLineId="reqLineId" :partId="partId" />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_PARTS)">
      <template v-slot:title>
        Cross/Alternatives &nbsp;<b-badge variant="primary">{{ alternativesList.length }}</b-badge>
      </template>
      <alternative-list :partId="partId" :crfqLineId="reqLineId" :statusId="statusId" :gridId="getGridId('alternative')"/>
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_ALL_POS)">
      <template v-slot:title>
        On Order &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
      </template>
      <orders-tab :reqLineId="reqLineId" :partId="partId" />
    </b-tab>
  </b-tabs>
</template>

<script>
import OffersTab from './Offers';
import SourcesTab from './Sources';
import InventoryTab from './Inventory';
import AlternativeList from '@/shared/components/Alternatives';
import OrdersTab from './OnOrder';
import { GRID_ID } from '@/shared/constants';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    OffersTab,
    SourcesTab,
    InventoryTab,
    AlternativeList,
    OrdersTab
  },
  props: {
    reqLineId: {
      type: [Number, String],
      default: 0
    },
    partId: {
      type: [Number, String],
      default: 0
    },
    statusId: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    ...mapState('offers', ['offersList']),
    // ...mapGetters('requirements', ['sourcesList']),
    ...mapState('requirements', ['sourcesList']),
    ...mapGetters('inventory', [ 'inventoryListForPartById' ]),
    ...mapGetters('alternatives', ['alternativesList' ]),
    ...mapGetters('purchaseorders', [ 'purchaseOrderLines' ]),
    inventoryListForPart() {
      return this.inventoryListForPartById(this.partId);
    },
    // offersCount(){
    //   return this.offersList.length
    // },
    // sourcesCount(){
    //   return this.sourcesList.length
    // }
  },
  methods:{
    getGridId(tabName){
      switch (tabName) {
        case 'alternative':
          return GRID_ID.REQUIREMENT_ALTERNATIVES
          break
      }
    }
  }
};
</script>
